function initialState() {
  return {
    previousRoute: {},
    currentRoute: {}
  };
}

const state = initialState();

const getters = {};

const actions = {
  updatePreviousRoute({ commit }, route) {
    commit('updateState', {
      prop: 'previousRoute',
      value: route
    });
  },
  updateCurrentRoute({ commit }, route) {
    commit('updateState', {
      prop: 'currentRoute',
      value: route
    });
  }
};

const mutations = {
  updateState(state, { prop, value }) {
    state[prop] = value;
  },
  resetState(state) {
    Object.assign(state, initialState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
